export const ROLE_ABO = 'ABO';
export const ROLE_MEMBER = 'PM';
export const ROLE_SM = 'SM';
export const ROLE_FOA = 'FOA';
/** ====================== 加价购标签 Start ====================== **/
export const MARKUP_PURCHASE = 'MARKUP_PURCHASE'; // 加价购标签
export const MARKUP_ACTIVITY_INFO = 'MARKUP_ACTIVITY_INFO' // 加价购活动详情
export const MARKUP_PURCHASE_LIST = 'MARKUP_PURCHASE_LIST' // 加价购 PLP 已选商品列表
export const MARKUP_MAX_QUANTITY_PURCHASE = 'MARKUP_MAX_QUANTITY_PURCHASE' // 加价购 加购商品最大可选数量信息
export const MARKUP_PRODUCT_ITEMCODE = 'MARKUP_PRODUCT_ITEMCODE' // 加价购  当前缓存关联主商品 itemCode 缓存
export const MARKUP_ADMIN_PURCHASSE_QUANTITY = 'MARKUP_ADMIN_PURCHASSE_QUANTITY' // 加价购 当前主商品已选数量
/** ====================== 加价购标签 End ====================== **/
export const USER_ALL_PROMOTIONS_LIST = 'USER_ALL_PROMOTIONS_LIST' // 登錄用戶命中的所有活動信息
/** ====================== 抽獎促銷 Start ====================== **/
export const PROMOTION_LOTTERY_SWITCH = 'PROMOTION_LOTTERY_SWITCH' // 促銷抽獎活動命中信息
export const PROMOTION_OERERS_LOTTERY_LIST = "PROMOTION_OERERS_LOTTERY_LIST" // 訂單中獎信息
export const PROMOTION_WINNING_PROMOTION_LOTTERY_LIST = "PROMOTION_WINNING_PROMOTION_LOTTERY_LIST" // 抽獎命中信息 多維度訂單
export const PROMOTION_LOTTERY_REFRESH_LOCK = "PROMOTION_LOTTERY_REFRESH_LOCK" // 用於控制用戶抽完獎後刷新瀏覽器 避免再次顯示抽獎組件
/** ====================== 抽獎促銷 End ====================== **/
/** ====================== 多比例促銷 Start ====================== **/
export const COMBINATION_MASTER_ITEM_CODE = 'COMBINATION_MASTER_ITEM_CODE'; //  1+N | 1+N+N 主商品 code
export const COMBINATION_MASTER_QUANTITY = 'COMBINATION_MASTER_QUANTITY'; //  1+N | 1+N+N 比例组合数量
export const COMBINATION_QUANTITIES = 'COMBINATION_QUANTITIES'; //  1+N | 1+N+N 比例组合 PDP 页面需要回显的内容
export const COMBINATION_CONSIGNEE_ADA = 'COMBINATION_CONSIGNEE_ADA'; //  1+N | 1+N+N 购货人 ada
/** ====================== 多比例促銷 End ====================== **/

export const SOP_ORDER_LIST_SELECTED = "SOP_ORDER_LIST_SELECTED"  //  用户选择的 SOP 订单列表
export const SOP_ORDER_SIGNID_LIST = "SOP_ORDER_SIGNID_LIST"  //  用户选择的 SOP 订单 signId 列表


/**==============TEP-16571 訪客購物 start=======================*/
export const SHOW_SOP_ORDER_REMINDER = "SHOW_SOP_ORDER_REMINDER" // 訪客連結進入長客計畫彈窗是否彈出過標識
export const VISITORS_PROMOTIONAL_DETAILS = "VISITORS_PROMOTIONAL_DETAILS" // 訪客限购落地頁面 訪客限购上級直銷商數據、登錄用戶綁定的手機信息、促销超链接UI数据
export const VISITORS_CART_PURCHASE_ITEM_CODE_LISTS = "VISITORS_CART_PURCHASE_ITEM_CODE_LISTS" // FOA、FOA访客 /mergeCart 合併購物車後，购物车商品 ItemCodeList
export const VISITOR_POP_UP = "VISITOR_POP_UP" // FOA訪客登錄流程當前彈出窗節點信息
export const SHARE_VISITORS_CONNECTION_INFO = "SHARE_VISITORS_CONNECTION_INFO" // 已發送訪客連繫資訊至服務直銷商標識
export const VISITORS_FORBID_PRODUCT_LABELS_ALREADY_REMOVED = "VISITORS_FORBID_PRODUCT_LABELS_ALREADY_REMOVED" // 访客不可购标记
export const VISITORS_FORBID_PRODUCT_SOP_ALREADY_REMOVED = "VISITORS_FORBID_PRODUCT_SOP_ALREADY_REMOVED" // /mergeCart 合併購物車後返回 FOA訪客購物車中有 SOP 商品标记
export const CONSIGNEE_GUEST_FLAG = "CONSIGNEE_GUEST_FLAG" // 登錄用戶是否访客的标记
export const VISITORS_FIRST_SHOPPING = "VISITORS_FIRST_SHOPPING" // 是否是第一次購貨
export const VISITORS_BINED_PHONE_NUMBER = "VISITORS_BINED_PHONE_NUMBER" // 登錄 FOA 手機號碼
export const VISITORS_UP_LEVEL_NUMBER = "VISITORS_UP_LEVEL_NUMBER" // 访客上级手机号码
export const VISITORS_CONTENT_STACK_DATA = "VISITORS_CONTENT_STACK_DATA" // LC登錄組件返回 是否彈出過個資告知彈出窗 標識
/**==============TEP-16571 訪客購物 End=======================*/


export const frontEndMessageCodes = {
  sample: 'CI.Success.Test',

  // ALL Shared
  SUCCESS_ADDCART: 'UI.CI.SUCCESS_ADDCART',
  FAILED_ADDCART: 'UI.CI.FAILED_ADDCART',

  // Privilege
  PV_RESELECT_FORMAT: 'UI.CI.PV_RESELECT_FORMAT',

  // Address
  ADR_SUCCESS_ADD_01: 'UI.CI.ADR_SUCCESS_ADD.01',
  ADR_SUCCESS_DEL: 'UI.CI.ADR_SUCCESS_DEL',
  ADR_SUCCESS_EDIT: 'UI.CI.ADR_SUCCESS_EDIT',
  ADR_SUCCESS_ADD_02: 'UI.CI.ADR_SUCCESS_ADD.02',
  ADR_SET_DEFAULT: 'UI.CI.ADR_SET_DEFAULT',
  ADR_SAVE_EDIT: 'UI.CI.ADR_SAVE_EDIT',
  ADR_EMPTY_ADR: 'UI.CI.ADR_EMPTY_ADR',
  ADR_EXCEED_F: 'UI.CI.ADR_EXCEED_F',
  ADR_EXCEED_X: 'UI.CI.ADR_EXCEED_X',
  ADR_EXCEED_R: 'UI.CI.ADR_EXCEED_R',
  ADR_EXCEED_A: 'UI.CI.ADR_EXCEED_A',
  ADR_EMPTY_NAME: 'UI.CI.ADR_EMPTY_NAME',
  ADR_EMPTY_MOBILE: 'UI.CI.ADR_EMPTY_MOBILE',
  ADR_VALID_MOBILE: 'UI.CI.ADR_VALID_MOBILE',
  ADR_VALID_POSTCODE: 'UI.CI.ADR_VALID_POSTCODE',
  ADR_VALID_CONTACT_01: 'UI.CI.ADR_VALID_CONTACT.01',
  ADR_VALID_CONTACT_02: 'UI.CI.ADR_VALID_CONTACT.02',
  ADR_EMPTY_DISTINCT: 'UI.CI.ADR_EMPTY_DISTINCT',
  ADR_EMPTY_CITY: 'UI.CI.ADR_EMPTY_CITY',
  ADR_OTHER_ADR: 'UI.CI.ADR_OTHER_ADR',
  ADR_EMPTY_RECEIVER: 'UI.CI.ADR_EMPTY_RECEIVER',
  ADR_VALID_MOBILE_FORMAT: 'UI.CI.ADR_VALID_MOBILE_FORMAT',

  // A40
  A40_FAILED_TRANSFER: 'UI.CI.A40_FAILED_TRANSFER',
  A40_INSUFFICIENT: 'UI.CI.A40_INSUFFICIENT',
  A40_RELEASE: 'UI.CI.A40_RELEASE',

  //Bulk Order
  BO_FAILED_SEARCH_PRD: 'UI.CI.BO_FAILED_SEARCH_PRD',
  BO_EXIST_PRD: 'UI.CI.BO_EXIST_PRD',
  BO_REMOVE_PRD: 'UI.CI.BO_REMOVE_PRD',

  //Favourite
  FAV_SELECT_ITEM: 'UI.CI.FAV_SELECT_ITEM',
  FAV_SUCCESS_DELETE: 'UI.CI.FAV_SUCCESS_DELETE',
  FAV_FAILED_DELETE: 'UI.CI.FAV_FAILED_DELETE',
  FAV_SELECT_OTHER_VAR: 'UI.CI.FAV_SELECT_OTHER_VAR',

  // My List
  MYLIST_SUCCESS_REMOVE: 'UI.CI.MYLIST_SUCCESS_REMOVE',
  MYLIST_SUCCESS_SHARE_LIST: 'UI.CI.MYLIST_SUCCESS_SHARE_LIST',
  MYLIST_SUCCESS_EDIT_PRD: 'UI.CI.MYLIST_SUCCESS_EDIT_PRD',
  MYLIST_SUCCESS_ADD: 'UI.CI.MYLIST_SUCCESS_ADD',
  MYLIST_SUCCESS_EDIT: 'UI.CI.MYLIST_SUCCESS_EDIT',
  MYLIST_REMOVE_LIST_XPRD: 'UI.CI.MYLIST_REMOVE_LIST_XPRD',
  MYLIST_REMOVE_LIST_1PRD: 'UI.CI.MYLIST_REMOVE_LIST_1PRD',
  MYLIST_SUCCESS_SHARE: 'UI.CI.MYLIST_SUCCESS_SHARE',
  MYLIST_FAILED_REMOVE: 'UI.CI.MYLIST_FAILED_REMOVE',
  MYLIST_FAILED_SHARE: 'UI.CI.MYLIST_FAILED_SHARE',
  MYLIST_MAX_ADD_10PRD: 'UI.CI.MYLIST_MAX_ADD_10PRD',
  MYLIST_SELECT_PRD: 'UI.CI.MYLIST_SELECT_PRD',
  MYLIST_REQUEST_LOGIN: 'UI.CI.MYLIST_REQUEST_LOGIN',
  MYLIST_SELECT_FORMAT: 'UI.CI.MYLIST_SELECT_FORMAT',
  MYLIST_MAX_10PRD: 'UI.CI.MYLIST_MAX_10PRD',
  MYLIST_SELECT_ALEAST_PRD: 'UI.CI.MYLIST_SELECT_ALEAST_PRD',
  MYLIST_OFS_PRD: 'UI.CI.MYLIST_OFS_PRD',
  MYLIST_LIST_NO_PRD: 'UI.CI.MYLIST_LIST_NO_PRD',
  MYLIST_NO_PRD: 'UI.CI.MYLIST_NO_PRD',
  SKU_TAG_NOT_BE_ALLOWED: 'MC.P.SKU_TAG_NOT_BE_ALLOWED.01',

  // Online Return
  OR_NO_FREEGIFT_ONLY: 'UI.CI.OR_NO_FREEGIFT_ONLY',
  OR_SELECT_ALEAST_PRD: 'UI.CI.OR_SELECT_ALEAST_PRD',
  OR_AC_EMPTY: 'UI.CI.OR_AC_EMPTY',
  OR_ID_EMPTY: 'UI.CI.OR_ID_EMPTY',
  OR_READ_REFUND: 'UI.CI.OR_READ_REFUND',
  OR_SUCCESS: 'UI.CI.OR_SUCCESS',
  OR_NAMETEL_EMPTY: 'UI.CI.OR_NAMETEL_EMPTY',
  OR_CONTACT_EMPTY: 'UI.CI.OR_CONTACT_EMPTY',
  OR_NAMETEL_EMPTY1: 'UI.CI.OR_NAMETEL_EMPTY1',
  OR_FAILED: 'UI.CI.OR_FAILED',
  OR_CANCEL_SUCCESS: 'UI.CI.OR_CANCEL_SUCCESS',
  OR_BOXNUM_EMPTY: 'UI.CI.OR_BOXNUM_EMPTY',

  // Orders
  ORD_NO_RECORD: 'UI.CI.ORD_NO_RECORD',
  ORD_COPY_LOGISTICS: 'UI.CI.ORD_COPY_LOGISTICS',
  ORD_SUCCESS_REPURCHASE: 'UI.CI.ORD_SUCCESS_REPURCHASE',
  ORD_PARTIAL_REPURCHASE: 'UI.CI.ORD_PARTIAL_REPURCHASE',
  ORD_FAILED_REPURCHASE: 'UI.CI.ORD_FAILED_REPURCHASE',
  ORD_EMPTY_PHONE: 'OM.B.NO_CONSIGNEE_PHONE.01',
  ORD_CANCEL_ORDER_PARAM_BLANK: 'UI.CI.ORD_CANCEL_ORDER_PARAM_BLANK',

  // Profile
  PROF_DUPLICATE_ADR: 'UI.CI.PROF_DUPLICATE_ADR',
  PROF_SUCCESS_ADD_NAME: 'UI.CI.PROF_SUCCESS_ADD_NAME',
  PROF_SUCCESS_EDIT_EMAIL: 'UI.CI.PROF_SUCCESS_EDIT_EMAIL',
  PROF_SUCCESS_ADD_EMAIL: 'UI.CI.PROF_SUCCESS_ADD_EMAIL',

  // Member Renew
  MR_POINT_INSUFFICIENT: 'UI.CI.MR_POINT_INSUFFICIENT',
  MR_SELECT_ONE: 'UI.CI.MR_SELECT_ONE',

  // Switch Recipient
  SR_SUCCESS_DELETE: 'UI.CI.SR_SUCCESS_DELETE',
  SR_SUCCESS_SWITCH: 'UI.CI.SR_SUCCESS_SWITCH',

  // Add To Cart
  CART_SELECT_VARIANT: 'UI.CI.CART_SELECT_VARIANT',
  CART_REQUEST_LOGIN: 'UI.CI.CART_REQUEST_LOGIN',

  // Coupon
  COUP_SUCCESS_REDEEM: 'UI.CI.COUP_SUCCESS_REDEEM',

  // Points
  POINT_SUCCESS_ADD: 'UI.CI.POINT_SUCCESS_ADD',
  POINT_RESELECT: 'UI.CI.POINT_RESELECT',

  // SOP
  SOP_MODINC_SUC: 'UI.CI.SOP_MODINC_SUC',
  SOP_FAILED_EDIT: 'UI.CI.SOP_FAILED_EDIT',
  SOP_SUCCESS_DATE: 'UI.CI.SOP_SUCCESS_DATE',
  SOP_SUCCESS_END: 'UI.CI.SOP_SUCCESS_END',
  SOP_SUCCESS_STOP: 'UI.CI.SOP_SUCCESS_STOP',
  SOP_SUCCESS_CANCEL: 'UI.CI.SOP_SUCCESS_CANCEL',
  SOP_FAILED_CANCEL: 'UI.CI.SOP_FAILED_CANCEL',
  SOP_SUCCESS_COMBINE: 'UI.CI.SOP_SUCCESS_COMBINE',
  SOP_FAILED_COMBINE: 'UI.CI.SOP_FAILED_COMBINE',
  SOP_REQUEST_INPUT: 'UI.CI.SOP_REQUEST_INPUT',
  SOP_SUCCESS_EDIT: 'UI.CI.SOP_SUCCESS_EDIT',
  SOP_FAILED_COMBINE: 'UI.CI.SOP_FAILED_COMBINE',
  SOP_ENTER_CC: 'UI.CI.SOP_ENTER_CC',
  SOP_SUCCESS_CREATE_TOKEN: 'UI.CI.SOP_SUCCESS_CREATE_TOKEN',
  SOP_SUCCESS_CREATE_TOKEN2: 'UI.CI.SOP_SUCCESS_CREATE_TOKEN2',
  SOP_BLIND_CARD: 'UI.CI.SOP_BLIND_CARD',
  SOP_SUCCESS_EDIT_PAYMENT: 'UI.CI.SOP_SUCCESS_EDIT_PAYMENT',
  SOP_SUCCESS_CHANGE: 'UI.CI.SOP_SUCCESS_CHANGE',
  SOP_SUCCESS_FREQUENCY: 'UI.CI.SOP_SUCCESS_FREQUENCY',
  SOP_FAILED_FREQUENCY: 'UI.CI.SOP_FAILED_FREQUENCY',
  SOP_SUCCESS_EVERYTHING: 'UI.CI.SOP_SUCCESS_EVERYTHING',
  SOP_FAILED_EVERYTHING: 'UI.CI.SOP_FAILED_EVERYTHING',
  SOP_SUCCESS_EDIT_ADR: 'UI.CI.SOP_SUCCESS_EDIT_ADR',
  SOP_SUCCESS_ADD_ADR: 'UI.CI.SOP_SUCCESS_ADD_ADR',
  SOP_RETURN_NULL: 'UI.CI.SOP_RETURN_NULL',
  SOP_SELECT_CITY: 'UI.CI.SOP_SELECT_CITY',
  SOP_SELECT_CC: 'UI.CI.SOP_SELECT_CC',
  SOP_SUCCESS_REMOVE_CC: 'UI.CI.SOP_SUCCESS_REMOVE_CC',
  SOP_DELIVERY_SUCCESS_FREQUENCY_DATE: 'UI.CI.SOP_DELIVERY_SUCCESS_FREQUENCY_DATE',
  SOP_DELIVERY_SUCCESS_FREQUENCY: 'UI.CI.SOP_DELIVERY_SUCCESS_FREQUENCY',
  SOP_DELIVERY_SUCCESS_DATE: 'UI.CI.SOP_DELIVERY_SUCCESS_DATE',
  SOP_PAYMENT_FAILED_CARD_NOT_SUPPORTED: 'UI.CI.SOP_PAYMENT_FAILED_CARD_NOT_SUPPORTED',
  SOP_PAYMENT_FAILED_CARD_VALIDATION: 'UI.CI.SOP_PAYMENT_FAILED_CARD_VALIDATION',
  SOP_PAYMENT_FAILED_CARD_SAME: 'UI.CI.SOP_PAYMENT_FAILED_CARD_SAME',
  SOP_DEDUCTION_RECORD_NOT_EXIST: 'OM.B.SOP_DEDUCTION_RECORD_NOT_EXIST.01',


  SOP_PAYMENT_SUCCESS: 'UI.CI.SOP_PAYMENT_SUCCESS',//  修改成功，訂單支付更改為 XXXX 方式。
  SOP_ADDRESS_SUCCESS: 'UI.CI.SOP_ADDRESS_SUCCESS',//  收貨地址修改成功。
  SOP_FREQUENCY_SUCCESS: 'UI.CI.SOP_FREQUENCY_SUCCESS',//  修改配送頻率 : 雙月 成功。
  SOP_DATE_SUCCESS: 'UI.CI.SOP_DATE_SUCCESS',//  修改配送日期成功，下次訂單配送日為 XXXX/XX/XX
  SOP_FREQUENCY_DATE_SUCCESS: 'UI.CI.SOP_FREQUENCY_DATE_SUCCESS',//  修改配送頻率 : XX 成功，下期訂單配送日為 XXXX/XX/XX
  SOP_TASTE_SUCCESS: 'UI.CI.SOP_TASTE_SUCCESS',// 修改口味成功。
  SOP_PLEASE_SELECT_SOP_ORDER: 'UI.CI.SOP_PLEASE_SELECT_SOP_ORDER',//  請選擇需要合併的SOP訂單

  //SSO
  LC_F_ALREADY_LOGIN: 'LC.F.ALREADY_LOGIN',
  //share bar
  SHAREBAR_SUCCESS_COPY: 'UI.CI.SHAREBAR_SUCCESS_COPY',

  // add cart outOfStock
  ADD_OUTOFSTOCK_CART: 'UI.CI.ADD_OUTOFSTOCK_CART',

  // 選擇加價購商品超過限制
  MARKUP_PURCHASE_MAX: 'OM.B.ADDON_PURCHASE_PRODUCT_QUANTITY_LIMITED.01',
  // 選擇加價購商品库存不足
  INSUFFICIENT_IVNVENTORY: 'UI.CI.INSUFFICIENT_IVNVENTORY',

  // 訪客第二次購貨阻擋簡訊通知上線 模板
  APPLY_FOR_THE_SECOND_SHOPPING_SMS_TO_INFO_THE_DISTRIBUTOR: 'UI.CI.APPLY_FOR_THE_SECOND_SHOPPING_SMS_TO_INFO_THE_DISTRIBUTOR'


};
